<div [ngSwitch]="item?.type" class="scaffold-option-items" *ngIf="checkIf()">
  <div *ngSwitchCase="'help'">
    <p>{{ item?.text }}</p>
  </div>
  <div *ngSwitchCase="'checkbox'" class="checkbox">
    <scaffold-toggle-slide
      status="info"
      [(ngModel)]="value"
      (change)="sendUpdate()"
      position="left">
      {{ item?.label
      }}<span nbSuffix *ngIf="item?.help" pTooltip="{{ item?.help }}">
        <i class="fas fa-question-circle"></i>
      </span>
    </scaffold-toggle-slide>
  </div>
  <div *ngSwitchCase="'select'">
    <!-- <nb-form-field> -->
    <div class="form-field" *ngIf="item?.array">
      <label>{{
        getSelectLabel(selectedItem[item?.param], item?.template)
      }}</label>

      <!-- <nb-select
        [(ngModel)]="value"
        (selectedChange)="sendUpdate()"
        placeholder="{{ item?.label }}"
        fullWidth="true"
      >
        <nb-option
          *ngFor="let obj of selectedItem[item?.array]; let i = index"
          [value]="i"
          [innerHTML]="obj[item?.key]"
        ></nb-option>
      </nb-select> -->

      <p-select
        placeholder="{{ item?.label }}"
        ngDefaultControl
        [options]="dataItems"
        [(ngModel)]="value"
        [optionLabel]="item?.key"
        (onChange)="sendUpdate()"
        [appendTo]="'body'">
        <ng-template #selectedItem let-selectedOption>
          {{ selectedOption.label }}
        </ng-template>

        <ng-template let-op #item>
          {{ op.label }}
        </ng-template>
      </p-select>
    </div>
    <div class="form-field" *ngIf="item?.data">
      <label>{{
        getSelectLabel(selectedItem[item?.param], item?.template)
      }}</label>

      <p-select
        placeholder="Data {{ item?.label }}"
        ngDefaultControl
        [options]="dataItems"
        [(ngModel)]="value"
        optionLabel="label"
        optionValue="key"
        (onChange)="sendUpdate()"
        [appendTo]="'body'">
        <ng-template #selectedItem let-selectedOption>
          {{ selectedOption.label }}
        </ng-template>

        <ng-template let-op #item>
          {{ op.label }}
        </ng-template>
      </p-select>
    </div>
    <div class="form-field">
      <label>{{ item?.label }}</label>
      <p-select
        *ngIf="!item?.data && !item?.array"
        ngDefaultControl
        [options]="item?.options | keyvalue"
        [(ngModel)]="value"
        optionLabel="key"
        optionValue="value"
        (onChange)="sendUpdate()"
        [appendTo]="'body'" />
    </div>

    <!-- </nb-form-field> -->
  </div>
  <div *ngSwitchCase="'background'">
    <!-- <nb-form-field> -->
    <div class="form-field">
      <label>{{ item?.label }}</label>
      <p-select
        [options]="colorOptions"
        optionValue="value"
        optionLabel="label"
        [appendTo]="'body'">
        <ng-template #selectedItem let-selectedOption>
          <span [class]="selectedOption?.value">{{
            selectedOption.label
          }}</span>
        </ng-template>

        <ng-template let-op #item>
          <span [class]="op?.value">{{ op.label }}</span>
        </ng-template>
      </p-select>
    </div>
    <!-- <nb-select
        [(ngModel)]="value"
        (selectedChange)="sendUpdate()"
        placeholder="{{ item?.label }}"
        fullWidth="true"
      >
        <nb-option value="">Normal</nb-option>
        <nb-option class="block-color-red" value="block-color-red"
          >Red</nb-option
        >
        <nb-option class="block-color-blue" value="block-color-blue"
          >Blue</nb-option
        >
        <nb-option class="block-color-green" value="block-color-green"
          >Green</nb-option
        >
        <nb-option class="block-color-light" value="block-color-light"
          >Light</nb-option
        >
        <nb-option class="block-color-med" value="block-color-med"
          >Medium</nb-option
        >
        <nb-option class="block-color-dark" value="block-color-dark"
          >Dark</nb-option
        >
      </nb-select>
    </nb-form-field> -->
  </div>
  <div *ngSwitchCase="'data_view'">
    <div *ngIf="dataViews.length > 0">
      <label>View Type</label>
      <p-select
        *ngIf="!item?.data && !item?.array"
        ngDefaultControl
        [options]="dataViewsOptions"
        [(ngModel)]="value"
        optionLabel="label"
        optionValue="value"
        (onChange)="sendUpdate()"
        placeholder="View Type"
        [appendTo]="'body'" />
    </div>
    <!-- <nb-select
        [(ngModel)]="value"
        (selectedChange)="sendUpdate()"
        placeholder="View Type"
        fullWidth="true"

      >
        <nb-option [value]="">None</nb-option>
        <nb-option *ngFor="let key of dataViews" [value]="key.name">{{
          key.name
        }}</nb-option>
      </nb-select> -->
    <!-- </nb-form-field> -->
  </div>
  <div *ngSwitchCase="'data_mode'">
    <div class="form-field">
      <label>View Type</label>
      dataModesOptions

      <p-select
        placeholder="View Type"
        ngDefaultControl
        [options]=""
        [(ngModel)]="value"
        optionLabel="key"
        optionValue="value"
        (onChange)="sendUpdate()"
        [appendTo]="'body'" />
    </div>

    <!-- <nb-select
        [(ngModel)]="value"
        (selectedChange)="sendUpdate()"
        placeholder="View Type"
        fullWidth="true"
      >
        <nb-option [value]="">None</nb-option>
        <nb-option *ngFor="let key of dataModes" [value]="key.mode">{{
          key.mode
        }}</nb-option>
      </nb-select>
    </nb-form-field> -->
  </div>

  <div *ngSwitchCase="'filter_values'">
    <app-keys-filter-input
      [item]="item"
      (changed)="triggerUpdate()"
      [selectedType]="selectedItem?.list_view"
      [typePreselected]="true"
      [selectedItem]="selectedItem"
      [parentView]="parentView"
      [rootItem]="rootItem"></app-keys-filter-input>
  </div>

  <div *ngSwitchCase="'map_values'">
    <app-map-value
      [item]="item"
      (changed)="triggerUpdate()"
      [selectedType]="selectedItem?.list_view"
      [typePreselected]="true"
      [selectedItem]="selectedItem"
      [parentView]="parentView"
      [rootItem]="rootItem"></app-map-value>
  </div>

  <div *ngSwitchCase="'translation_key'">
    <app-translation-key
      (changed)="triggerUpdate()"
      [selectedType]="selectedItem?.list_view"
      [typePreselected]="true"
      [selectedItem]="selectedItem"
      [parentView]="parentView"
      [rootItem]="rootItem"
      [label]="item?.label"
      [param]="item?.param"></app-translation-key>
  </div>

  <div *ngSwitchCase="'key-select'">
    <app-key-select
      [item]="item"
      (changed)="triggerUpdate()"
      [selectedType]="selectedItem?.list_view"
      [typePreselected]="true"
      [selectedItem]="selectedItem"
      [parentView]="parentView"
      [rootItem]="rootItem"></app-key-select>
  </div>

  <div *ngSwitchCase="'other_mode'">
    <div *ngIf="other_modes && other_modes.length > 0">
      <div style="display: flex">
        <div style="flex: 1" class="form-field">
          <!-- <nb-form-field> -->
          <label>{{ item?.label }}</label>
          <p-select
            [(ngModel)]="selectedItem[item?.param]"
            [options]="dataModesOptions"
            placeholder="{{ item?.label }}"
            (onChange)="getViewID()"
            [style]="{ width: '100%' }">
          </p-select>
          <!-- <nb-select
            [(ngModel)]="selectedItem[item?.param]"
            placeholder="{{ item?.label }}"
            (selectedChange)="getViewID()"
            fullWidth="true"
          >
            <nb-option-group
              *ngFor="let group of other_modes"
              [label]="group.type"
            >
              <nb-option *ngFor="let mode of group.modes" [value]="mode.mode">
                {{ mode.mode }}
              </nb-option>
            </nb-option-group>
          </nb-select> -->
          <span *ngIf="item?.help" pTooltip="{{ item?.help }}">
            <i class="fas fa-question-circle"></i>
          </span>
          <!-- </nb-form-field> -->
        </div>
        <div *ngIf="other_id">
          <a
            target="_blank"
            [href]="'/views/' + other_id"
            (click)="openInNewTab('/views/' + other_id)"
            >Open</a
          >
        </div>
      </div>
    </div>
    <div *ngIf="!other_modes || other_modes.length == 0">
      <div class="form-field">
        <label>{{ item?.label }}</label>
        <input
          pInputText
          placeholder="{{ item?.label }}"
          [(ngModel)]="selectedItem[item?.param]"
          fluid />
        <p-inputgroup-addon *ngIf="item?.help" pTooltip="{{ item?.help }}">
          <i class="fas fa-question-circle"></i>
        </p-inputgroup-addon>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'model'">
    <!-- <nb-form-field *ngIf="parentView && parentView.keys && parentView.keys.length > 1">
       <nb-select [(ngModel)]="selectedItem[item?.param]" placeholder="{{item?.label}}">
         <nb-option value="">None</nb-option>
         <nb-option *ngFor="let key of dataKeys" [value]="key.name">{{key.friendlyname || key.name}}</nb-option>
       </nb-select>
     </nb-form-field>-->
    <app-model-input
      [item]="item"
      [selectedItem]="selectedItem"
      [parentView]="parentView"
      [rootItem]="rootItem"
      (changed)="triggerUpdate()"></app-model-input>
  </div>
  <div *ngSwitchCase="'icon'">
    <p>
      Scaffold uses Font Awesome icon classes. Type a part of the class name to
      find and icon.
    </p>
    <div class="form-field">
      <p-autocomplete
        [(ngModel)]="value"
        [suggestions]="filteredIcons"
        (completeMethod)="_filterIcons($event)"
        (onSelect)="sendUpdate()"
        placeholder="{{ item?.label }}"
        [virtualScroll]="true"
        [virtualScrollItemSize]="34">
        <ng-template let-icon #item>
          <i [class]="icon"></i>
        </ng-template>
      </p-autocomplete>
      <p-button severity="contrast" variant="text"
        ><i [class]="value"></i
      ></p-button>
    </div>
  </div>

  <div *ngSwitchCase="'settings_array'" class="settings-array">
    <button
      pButton
      severity="primary"
      class="btn btn-default"
      (click)="openSettings(selectedItem, item)"
      fullWidth="true">
      Edit {{ item?.label }}
    </button>
  </div>

  <div *ngSwitchCase="'column'">
    <label>{{ item?.label }}</label>
    Columns are based on a total width of 12 units. Select the number of units
    per column.
    <div
      *ngFor="let input of selectedItem[item?.countParam]; let $index = index"
      class="column-item">
      <!-- <nb-form-field> -->
      <label>Column {{ $index + 1 }}</label>

      <p-select
        placeholder="Column {{ $index + 1 }}"
        ngDefaultControl
        [options]="
          getColumnWidths(
            selectedItem[item?.param],
            selectedItem[item?.param][$index]
          )
        "
        [(ngModel)]="selectedItem[item?.param][$index]"
        [appendTo]="'body'" />

      <!-- <nb-select
          [(ngModel)]="selectedItem[item?.param][$index]"
          placeholder="Column {{ $index + 1 }}"
          fullWidth="true"
        >
          <nb-option
            *ngFor="
              let width of getColumnWidths(
                selectedItem[item?.param],
                selectedItem[item?.param][$index]
              )
            "
            [value]="width"
            >{{ width }}</nb-option
          >
        </nb-select> -->
      <!-- </nb-form-field> -->
      <p-button
        severity="link"
        variant="text"
        class="pull-right"
        title="Remove {{ item?.label }}"
        (click)="
          selectedItem[item?.param].splice($index, 1);
          selectedItem[item?.countParam].splice($index, 1)
        ">
        <i class="fat fa-trash-alt"></i>
      </p-button>
      <i
        style="cursor: help"
        class="fas fa-question-circle"
        status="accent"
        *ngIf="
          getColumnWidths(
            selectedItem[item?.param],
            selectedItem[item?.param][$index]
          ).length === 0
        "
        title="Reduce the width of other columns to make room for this column"></i>
    </div>
  </div>

  <div *ngSwitchCase="'text'" class="scaffold-text-input">
    <div class="form-field">
      <label>{{ item?.label }}</label>
      <br />
      <p-inputgroup>
        <input
          pInputText
          placeholder="{{ item?.label }}"
          [(ngModel)]="value"
          (change)="checkValue($event)"
          (input)="sendUpdate()"
          fluid />
        <p-inputgroup-addon *ngIf="item?.help" pTooltip="{{ item?.help }}">
          <i class="fas fa-question-circle"></i>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
  </div>
  <div *ngSwitchCase="'color'" class="scaffold-text-input">
    <!-- PRIMENG TODO: Add a color picker? -->
    <div class="form-field">
      <label>{{ item?.label }}</label>
      <p-inputgroup>
        <p-inputgroup-addon
          [style]="{ backgroundColor: value, padding: '0px' }">
          <p-colorpicker
            [(ngModel)]="value"
            (onChange)="sendUpdate()"
            [styleClass]="'theme-color-picker'" />
        </p-inputgroup-addon>
        <input
          pInputText
          type="text"
          [(ngModel)]="value"
          placeholder="Color"
          (input)="sendUpdate()" />
      </p-inputgroup>
    </div>
  </div>
  <div
    *ngSwitchCase="'textparam'"
    class="scaffold-text-input"
    style="display: flex">
    <div class="form-field">
      <label>{{ item?.label + " (param: '" + item?.param + "')" }}</label>
      <p-inputgroup>
        <input
          pInputText
          placeholder="{{ item?.label + ' (param: \'' + item?.param + '\')' }}"
          [(ngModel)]="value"
          (input)="sendUpdate()"
          fluid />
        <p-inputgroup-addon *ngIf="item?.help" pTooltip="{{ item?.help }}">
          <i class="fas fa-question-circle"></i>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
  </div>
  <div *ngSwitchCase="'file'">
    <div>
      <button
        pButton
        severity="primary"
        (click)="selectFile(selectedItem, item?.param)"
        fullWidth="true">
        Select File
      </button>
    </div>
  </div>
  <div *ngSwitchCase="'file_image'">
    <div>
      <button
        pButton
        severity="primary"
        (click)="selectFile(selectedItem, item?.param, 'image')">
        Select Image
      </button>
    </div>
    <div>
      <button pButton *ngIf="!hideClearImageBtn" (click)="unSelectFile()">
        Clear Image
      </button>
    </div>
  </div>
  <div *ngSwitchCase="'number'">
    <div class="form-field">
      <label>{{ item?.label }}</label>
      <p-inputgroup>
        <p-inputnumber
          placeholder="{{ item?.label }}"
          [(ngModel)]="value"
          (onInput)="sendUpdate()"
          fluid />
        <p-inputgroup-addon *ngIf="item?.help" pTooltip="{{ item?.help }}">
          <i class="fas fa-question-circle"></i>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
  </div>

  <div *ngSwitchCase="'array_length'">
    <div>
      <button
        pButton
        severity="primary"
        (click)="arrayLength(selectedItem, item?.param, 1, item?.defaults)"
        fullWidth="true">
        Add {{ item?.label }}
      </button>
    </div>
  </div>
  <div
    *ngSwitchCase="'youtube_url'"
    class="scaffold-text-input"
    style="display: flex">
    <div class="form-field">
      <label>{{ item?.label }}</label>
      <p-inputgroup>
        <input
          pInputText
          placeholder="{{ item?.label }}"
          [(ngModel)]="value"
          (input)="extractYoutubeId()"
          fluid />
        <p-inputgroup-addon *ngIf="item?.help" pTooltip="{{ item?.help }}">
          <i class="fas fa-question-circle"></i>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
  </div>
  <div *ngSwitchCase="'data_search'">
    <div *ngIf="!item?.toload_type" class="form-field">
      <label>View Type</label>
      <br />
      <p-select
        placeholder="View Type"
        ngDefaultControl
        [options]="dataViews"
        [(ngModel)]="selectedItem.toload_type"
        optionLabel="name"
        optionValue="name"
        [appendTo]="'body'" />
    </div>
    <div>
      <button
        pButton
        severity="primary"
        class="btn btn-default"
        (click)="
          openSearch(
            selectedItem,
            item?.param,
            item?.toload_type || selectedItem.toload_type
          )
        "
        [disabled]="!item?.toload_type && !selectedItem.toload_type"
        fullWidth="true">
        Search for {{ item?.toload_type || selectedItem.toload_type }}
      </button>
    </div>
  </div>
  <div *ngSwitchCase="'array_values'">
    <label>{{ item?.label }}</label>
    <div class="inline-input">
      <input
        style.width="{{ 100 / selectedItem[item?.countParam].length + '%;' }}"
        *ngFor="let input of selectedItem[item?.countParam]; let $index = index"
        type="text"
        class="input-box"
        [(ngModel)]="selectedItem[item?.param][$index]" />
    </div>
  </div>
  <div *ngSwitchCase="'settings_object'">
    <label>{{ item?.label }}</label>
    <div class="inline-input">
      <app-controls
        *ngFor="let control of item?.settings"
        [item]="control"
        [selectedItem]="selectedItem[item?.param]"
        [rootItem]="rootItem"
        [parentView]="parentView"></app-controls>
    </div>
  </div>
</div>
